import { useState } from "react";
import Header from "./components/header";
import Modal from "./components/modal";
import { BundleAI } from "./components/bundle-ai";
import { Sponsored } from "./components/sponsored";
import { MainText } from "./components/main-text";
import { Subtext } from "./components/subtext";
import Discover from "./components/discover";

function App() {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };
  return (
    <div id="App">
      <Modal modalOpen={modalOpen} handleModalClose={handleModalClose} />
      <div className="layout">
        <Header />
        <div className="container">
          <Sponsored />
          <MainText />
          <Subtext />
          <BundleAI />
          <button
            className="how-its-work"
            style={{
              pointerEvents: modalOpen ? "none" : "auto",
            }}
            onClick={handleModalOpen}
          >
            <span>Nasıl çalışıyor?</span>
          </button>
          <Discover />
        </div>
      </div>
      <div className="top-ellipse"></div>
      <div className="bottom-ellipse"></div>
    </div>
  );
}

export default App;
